import * as CONSTANTS from './constants';

export const cancelDeferredTransactionRequest = (payload) => ({
  type: CONSTANTS.CANCEL_DEFERRED_TRANSACTION_REQUEST,
  payload
});
export const cancelDeferredTransactionSuccess = (data) => ({
  type: CONSTANTS.CANCEL_DEFERRED_TRANSACTION_SUCCESS,
  data
});
export const cancelDeferredTransactionFail = (error) => ({
  type: CONSTANTS.CANCEL_DEFERRED_TRANSACTION_FAIL,
  error
});

export const checkIfCanceledDeferredTransactionRequest = (transactionId) => ({
  type: CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_REQUEST,
  payload: {
    transactionId
  }
});
export const checkIfCanceledDeferredTransactionSuccess = (data) => ({
  type: CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_SUCCESS,
  data
});
export const checkIfCanceledDeferredTransactionFail = (error) => ({
  type: CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_FAIL,
  error
});

export const fetchDeferredCompanyTransactionRequest = (payload) => ({
  type: CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_REQUEST,
  payload
});

export const fetchDeferredCompanyTransactionSuccess = (data) => ({
  type: CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_SUCCESS,
  data
});

export const fetchDeferredCompanyTransactionFail = (error) => ({
  type: CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_FAIL,
  error
});

export const fetchDeferredUserTransactionRequest = () => ({
  type: CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_REQUEST
});

export const fetchDeferredUserTransactionSuccess = (data) => ({
  type: CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_SUCCESS,
  data
});

export const fetchDeferredUserTransactionFail = (error) => ({
  type: CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_FAIL,
  error
});
